export default __webpack_public_path__ + "static/media/logo-1.9f145b75.png";